import { render } from "./VacancyPage.vue?vue&type=template&id=33a2980f&scoped=true"
import script from "./VacancyPage.vue?vue&type=script&lang=js"
export * from "./VacancyPage.vue?vue&type=script&lang=js"

import "./VacancyPage.vue?vue&type=style&index=0&id=33a2980f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a2980f"]])

export default __exports__